import React from 'react';
import Header from './Header';
import Footer from './Footer';
export default function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <>
      <Header data-id="element-63" />
      <main data-id="element-64">{children}</main>
      <Footer data-id="element-65" />
    </>;
}
export { Layout };